export default __webpack_public_path__ + "static/media/KZ.T.04.2346 black.cc8022b9.svg";